<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/user-management'}">User Management</router-link>
      </li>
      <li class="active">Aktivasi User</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Aktivasi User</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Aktivasi User</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Upload File .CSV</label>
                  <div class="col-md-4 col-xs-12">
                      <input type="file" class="form-control" v-on:change="handleFile()" ref="file"><br/>
                      <a style="margin:10px;font-size:13px;" href="data:application/csv;base64,ZW1haWwKZmFraHJ5YXNhZHNzaTI5MDNAZ21haWwuY29tCmJhZ3VzYWxkeWNreUBnbWFpbC5jb20K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" download="example.csv">Download contoh file disini <i class="fa fa-download"></i></a>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Masa Berlaku</label>
                  <div class="col-md-2 col-xs-2">
                    <input type="number" min="0" class="form-control" v-model="period">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Pilih Fitur</label>
                  <div class="col-md-5 col-xs-4">
                    <div class="row">
                        <div class="col-md-6" v-for="(item, index) in featureList" v-bind:key="index">
                          <input type="checkbox" class="checkbox m-r-5" v-model="features" :value="item">
                          <span class="f-s-14 f-w-700 m-r-10">
                            {{item === 'INSTANT_TRYOUT' ? 'Tryout Instan': item === 'ITEM_BANK' ? 'Bank Soal' : item === 'SCHEDULED_TRYOUT' ? 'Tryout Terjadwal' : item === 'VIDEO' ? 'Video Pembelajaran' : ''}}
                          </span>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right">
                <button v-if="!$route.params.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
                <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import moment from 'moment'
import axios from 'axios'
import UsmanService from '@/services/usman.js'

export default {
  name: 'mapel-form',
  components: {
    'app-spinner': Spinner,
    'app-modal': Modal
  },
  data: function() {
    return {
      isLoading: false,
      showModal: false,
      errors: [],
      featureList: ['SCHEDULED_TRYOUT','INSTANT_TRYOUT', 'ITEM_BANK', 'VIDEO'],
      file: null,
      features: []
    }
  },
  computed: {
    fitur: {
      get: function() {
        return this.$store.state.usman.fitur
      },
      set: function(value) {
        this.$store.commit('usman_set_fitur', value)
      }
    },
    period: {
      get: function() {
        return this.$store.state.usman.period
      },
      set: function(value) {
        this.$store.commit('usman_set_period', value)
      }
    },
  },
  methods: {
    validateForm: function() {
      this.errors = []
      
      if (this.file == null) this.errors.push('File wajib diisi')
      
      if(this.file !== null){
        var lastChar = this.file.name.substr(this.file.name.length - 3);
        if(lastChar !== 'csv') this.errors.push('Tipe File wajib CSV')
      }
      
      if (this.features.length < 1) this.errors.push('Fitur wajib diisi')
      if (this.period < 1) this.errors.push('Masa Berlaku tidak boleh kosong')
      return this.errors.length == 0
    },
    handleFile: function() {
      this.file = this.$refs.file.files[0]
    },
    saveData: function() {
      if (!this.validateForm()) {
        return
      }
      var fit = ""
      for(var i = 0; i < this.features.length; i++){
        fit += this.features[i] + ','
      }
      this.isLoading = true
      var context = this
      let formData = new FormData()
      formData.append('file', context.file)
      formData.append('request', '{"duration":"'+ context.period +'", "features":"' + fit.slice(0, -1) + '"}')
      UsmanService.uploadFile(formData ,function (result){
        context.isLoading = false
        if(result.success){
          alert('Berhasil diupload')
          context.$router.push('/user-management')
        } else {
          alert('Gagal Upload')
        }
        
      })      
    },
  },
  mounted: function () {
    var context = this
      context.features = []
      context.period = 0
      context.file = null
  }
}
</script>



// WEBPACK FOOTER //
// UserBulkActivation.vue?ab0633ae